module.exports = __webpack_public_path__ + "img/thumbnail_RingTailedLemur_m_normal.9a7785ec.png";